import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { invalidateMany } from './queryUtils';
import {
  getHeldRobotTasks,
  overrideRobotHold,
  type HeldRobotTask,
} from '../services/api/robotHolds';

/**
 * MKS-241 — kept out of useBotAdmin.ts on purpose: BotAdminPage tests mock that
 * module with a fixed factory, and these hooks only run behind the release flag.
 */
export const robotHoldsKey = (projectId: number | undefined) =>
  ['bot-admin-robot-holds', projectId] as const;

export function useHeldRobotTasks(projectId: number | undefined) {
  return useQuery<HeldRobotTask[]>({
    queryKey: robotHoldsKey(projectId),
    queryFn: () => getHeldRobotTasks(projectId!),
    enabled: !!projectId,
    staleTime: 30 * 1000,
  });
}

export function useOverrideRobotHold(projectId: number | undefined) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (taskId: number) => overrideRobotHold(taskId),
    onSuccess: () => {
      invalidateMany(queryClient, [
        robotHoldsKey(projectId),
        ['bot-admin-routed-tasks', projectId],
      ]);
    },
  });
}
